import { render, staticRenderFns } from "./colorize-suggestion.vue?vue&type=template&id=308d1007"
import script from "./colorize-suggestion.vue?vue&type=script&lang=js"
export * from "./colorize-suggestion.vue?vue&type=script&lang=js"
import style0 from "./colorize-suggestion.vue?vue&type=style&index=0&id=308d1007&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports